export default {
  fastRegistration: 'Быстрая регистрация',
  userEnter: 'вход для клиентов',
  contacts: 'контакты',
  findOutTheCost: 'Узнать стоимость',
  brand: 'SOVTES',
  register: 'Зарегистрироваться',
  metaTags: {
    metaTitle:
      'Sovtes - онлайн логистика, управление грузоперевозками, ЕТТН, веб-приложение',
    metaDecription:
      'Sovtes - веб-приложение по контролю грузоперевозок. позволяет эффективно управлять грузовыми перевозками за счет автоматизации логистических процессов. регистрация электронной товарно-транспортной накладной, ЕТТН',
    metaKeywords:
      'Грузоперевозки, свободные маршруты для перевозчиков, онлайн логистика, программа sovtes, совтес, ЕТТН',
    ttnDescription:
      'Позволяет зарегистрировать электронную товарно-транспортную накладную онлайн бесплатно с цифровой подписью в Украине, добавить ЕТТН',
    ttnKeywords:
      'Регистрация ТТН онлайн бесплатно, ЕТТН, электронная товарно транспортная накладная с цифровой подписью, программа Sovtes, Совтес, ЕТТН',
    ttnTitle: 'Регистрация ТТН онлайн бесплатно в Украине, ЕТТН, eTTN - Sovtes',
    thankyouTitle: 'Спасибо - Sovtes',
    thankyou2Title: 'Спасибо - Sovtes',
    thankyou3Title: 'Спасибо - Sovtes',
    thankyou4Title: 'Спасибо - Sovtes',
    thankyou5Title: 'Спасибо - Sovtes',
    thankyou6Title: 'Спасибо - Sovtes',
  },
  nav: {
    links: {
      1: 'о продукте',
      5: 'аудит',
      2: 'перевозчику',
      3: 'заказчику',
      4: 'цена',
    },
  },
  sectionMain: {
    msg1: 'до 25% реальной экономии',
    msg2: 'на грузоперевозках',
    registration: 'Регистрация',
    knowMore: 'Узнать больше о продукте',
    thankyou1: 'Спасибо! В ближайшее время мы с вами свяжемся',
    thankyou2: 'Спасибо! В ближайшее время мы с вами свяжемся',
    thankyou3: 'Спасибо! В ближайшее время мы с вами свяжемся',
    thankyou4: 'Спасибо! В ближайшее время мы с вами свяжемся',
    thankyou5: 'Спасибо! В ближайшее время мы с вами свяжемся',
    thankyou6: 'Спасибо! В ближайшее время мы с вами свяжемся',
    ettn1: 'Спасибо за подписание ЕТТНА',
    ettn2: 'Для продолжения нажмите на синюю кнопку «ЕТТН подписано» ниже',
    ttn1: 'Регистрация ЕТТН бесплатно: электронные ТТН в Украине',
    ttn2: 'Регистрируйтесь и мы Вас подключим к ЕТТН',
  },
  sectionSlogan: {
    msg1: 'Ваша основная система управления автотранспортной логистикой',
    msg2: 'это SAAS-решение для выгодного управления грузоперевозками',
  },
  sectionPositions: {
    list: {
      1: 'простота',
      2: 'эффективность',
      3: 'доступность',
    },
    msg1:
      'Узнайте, как решить логистические проблемы бизнеса, который использует наемный транспорт для доставки груза. На ваш email мы вышлем бесплатную презентацию, специально разработанную нашими экспертами.',
  },
  sectionAudit: {
    title: 'аудит тарифов на перевозки',
    footer: {
      txt1: 'ООО Совтес является одним из',
      link:
        '7 утвержденных поставщиков электронной товарно-транспортной накладной Украины.',
      txt2:
        'Подключайтесь к центральному реестру ЕТТН с помощью утвержденного поставщика',
    },
  },
  sectionAdvantages: {
    title: 'Преимущества',
    shipper: 'Заказчику',
    transporter: 'Перевозчику',
    lists: {
      transporter: {
        11: {
          label: 'Актуальные заказы',
          description:
            'Sovtes сотрудничает только с прямыми заказчиками, исключает возможность дублирования заказов на перевозку.',
        },
        12: {
          label: 'Выгодное партнерство',
          description:
            'Став партнером Sovtes, вы получаете доступ ко всем заявкам наших клиентов без необходимости заключения дополнительных договоров.',
        },
        13: {
          label: 'Быстрые контракты',
          description:
            'Заказ в Sovtes содержит все необходимые данные о перевозке. Достаточно предложить транспортное средство и подписать заявку, которая формируется автоматически. Никаких звонков.',
        },
        14: {
          label: 'Быстрая оплата',
          description:
            'Оформляя перевозки через Sovtes, вы гарантированно получаете оплату за выполненную перевозку в течение 10 дней после разгрузки.',
        },
        15: {
          label: 'Новые клиенты',
          description:
            'Мы постоянно работаем над привлечением новых заказчиков транспортных услуг, вам необходимо лишь выбрать, с кем и на каких условиях работать.',
        },
        16: {
          label: 'Уменьшение расходов',
          description:
            'Простой и порожние пробеги съедают вашу прибыль. Мы предлагаем уменьшить количество простоев и пустых поездок за счет доступа к большему количеству актуальных заявок на перевозку.',
        },
      },
      shipper: {
        21: {
          label: 'Быстрый запуск',
          description:
            'Полный запуск системы на предприятии происходит менее чем за 5 дней.',
        },
        22: {
          label: 'Экономия',
          description:
            'Система SOVTES гарантированно снижает затраты на автоперевозки на 22-25%.',
        },
        23: {
          label: 'Отчетность',
          description:
            'Автоматические своевременные и достоверные отчеты по вашим сделкам.',
        },
        24: {
          label: 'Скорость',
          description:
            'Поиск нужного транспорта происходит за считанные минуты.',
        },
        25: {
          label: 'Электронный документооборот',
          description:
            'Максимально упрощает и ускоряет свою работу с перевозчиками.',
        },
        26: {
          label: 'Интеграция',
          description:
            'Автоматизированный обмен данными с различными ERP-системами вашего бизнеса.',
        },
      },
    },
  },
  partners: {
    title: 'партнеры',
    subTitle: 'Только для клиентов системы Sovtes:',
    list: {
      1: {
        description:
          'Первые два месяца использования сервиса «Вчасно» бесплатно',
      },
      2: {
        description:
          'Соучредитель Sovtes Олег Рудковский является председателем комитета по транспорту и логистике СУП (Союз Украинских Предпринимателей)',
      },
    },
  },
  clientsSection: {
    title: 'клиенты',
    list: {
      1: {
        name: 'Алексей Нодь',
        rank: 'Руководитель отдела транспортной логистики МЧП "АТ"',
        comment:
          'С командой мы сотрудничаем с 2014 года. Хотим выразить Sovtes благодарность за создание эффективного продукта, постоянно развивается! Благодаря вашему портала мы получили новых партнеров по бизнесу, значительно сократили время на обработку заявок и обеспечили транспорт постоянными загрузками. Мы желаем дальнейшего процветания проекта! Только вперед!',
      },
      2: {
        name: 'Анна Хватова',
        rank: 'Начальник отдела транспортной логистики ООО «ТД Щедро»',
        comment:
          'Среди главных преимуществ стоит отметить возможность организации полной прозрачности проведения тендерной процедуры, а также экономию средств и времени на решение задач. Для нашей компании внедрение системы стало одним из самых эффективных методов обеспечения добросовестной конкуренции и прозрачности проведения закупки транспортных услуг.',
      },
      3: {
        name: 'Лилия Кушнарева',
        rank:
          'Директор административно-логистического департамента Global Spirits (ТМ Хортица)',
        comment:
          'С SOVTES мы сотрудничаем больше года. Это многофункциональная информационная программа, которая обеспечивает экономию нашего времени и средств. С помощью SOVTES вы и ваши перевозчики всегда будете владеть up-to-date информации. Платформа SOVTES отличается удобством использования и надежностью хранения информации. Рекомендуем сотрудничество!',
      },
    },
  },
  howItWorks: {
    title: 'как это работает',
    list: {
      1: {
        label: 'Отчетность',
        description:
          'Перечень данных, хранящихся позволяет составлять необходимую отчетность в соответствии с требованиями наших клиентов. По заказу клиентов мы разрабатываем персонализированные отчеты, система автоматически генерирует и отправляет их соответствующему лицу.',
      },
      2: {
        label: 'Документооборот',
        description:
          'Электронный документооборот и автоматическое создание документов позволяют существенно повысить уровень безопасности, исключить риски потери документов, снизить затраты на корреспонденцию до 99% и ускорить обмен документами до нескольких минут.',
      },
      3: {
        label: 'Простота взаимодействия',
        description:
          'После публикации заявки все перевозчики мгновенно и одновременно получают информацию о заказе. Функционал SOVTES обеспечивает легкий обмен данными - как от заказчика к перевозчикам, так и в обратном направлении для быстрого оформления соглашения на перевозку.',
      },
      4: {
        label: 'Учет',
        description:
          'Все действия и важнейшие показатели сохраняются в надежно защищенных базах данных. Возможность интеграции через API обеспечивает передачу необходимой информации в ERP-системы наших клиентов. Хранение и передача данных полностью автоматизированы и не требуют человеческих ресурсов.',
      },
    },
  },
  aboutSection: {
    subTitle:
      'Сервис, который позволит контролировать доставку грузов на всех этапах транспортировки, получать актуальную статистику по вашим перевозкой и работать с документацией.',
  },
  sectionPrice: {
    title1: 'стоимость для заказчика',
    msg1: 'зависит от количества перевозок, которую вы осуществляете за месяц.',
  },
  forms: {
    shipper: 'Я заказчик',
    transporter: 'Я перевозчик',
  },
  footer: {
    msg1: 'регистрация ЕТТН онлайн',
    address: {
      city: '04112, г. Киев,',
      street: 'ул. Дорогожицкая 3,',
      house: 'Unit City, В9, оф. 414',
    },
  },
}
